import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'KaraBloc',
  description:
    'KaraBloc is a DeFi Hub on BNB Chain, Polygon, & Ethereum. Swap, stake, and lend cryptocurrencies, from stablecoins to altcoins - all in one place.',
  image: 'https://i.ibb.co/1shQSCC/kara.png',
}

export const customMeta: { [key: string]: PageMeta } = {
  '/': {
    title: 'Home Page | KaraBloc',
    description:
      'KaraBloc is a DeFi Hub on BNB Chain, Polygon, & Ethereum. Swap, stake, and lend cryptocurrencies, from stablecoins to altcoins - all in one place.',
  },
  '/swap': {
    title: 'Swap | KaraBloc',
    description: 'Swap between hundreds of crypto tokens using our decentralized exchange.',
  },
  '/apestats': {
    title: 'ApeStats | KaraBloc',
    description: 'Track your portfolio on KaraBloc using our custom dashboard.',
  },
  '/nft': {
    title: 'Non Fungible Apes | KaraBloc',
    description: 'Buy and sell KaraBloc NFTs and join our NFT community.',
  },
  '/farms': {
    title: 'BANANA Farms | KaraBloc',
    description: 'Stake your liquidity provider (LP) tokens in BANANA Farms to earn BANANA.',
  },
  '/jungle-farms': {
    title: 'Jungle Farms | KaraBloc',
    description: 'Stake your liquidity provider (LP) tokens to earn partner project tokens.',
  },
  '/pools': {
    title: 'Staking Pools | KaraBloc',
    description: 'Stake BANANA in Staking Pools to earn partner project tokens.',
  },
  '/liquidity': {
    title: 'Liquidity | KaraBloc',
    description: 'Add liquidity to the KaraBloc decentralized exchange to create LPs and earn trading fees.',
  },
  '/add-liquidity': {
    title: 'Liquidity | KaraBloc',
    description: 'Add liquidity to the KaraBloc decentralized exchange to create LPs and earn trading fees.',
  },
  '/iao': {
    title: 'Initial Ape Offerings | KaraBloc',
    description: 'Launch your crypto project with KaraBloc, or commit into Initial Ape Offerings.',
  },
  '/gnana': {
    title: 'GNANA | KaraBloc',
    description: 'Convert your BANANA to GNANA to gain exclusive access to governance, pools, and more.',
  },
  '/maximizers': {
    title: 'BANANA Maximizers | KaraBloc',
    description: 'Stake your liquidity provider (LP) tokens in auto-compounding vaults to earn BANANA.',
  },
  '/auction': {
    title: 'Auction | KaraBloc',
  },
  '/staking': {
    title: 'NFA Staking | KaraBloc',
  },
  '/treasury-bills': {
    title: 'Treasury Bills | KaraBloc',
    description: 'Get BANANA and partner project tokens at a discount using your liquidity provider (LP) tokens.',
  },
  '/limit-orders': {
    title: 'Limit Orders | KaraBloc',
    description: 'Trade crypto tokens at the price you want using limit orders on the KaraBloc DEX.',
  },
}
